import { render } from "./HelpButton.vue?vue&type=template&id=521b9c3e&scoped=true"
import script from "./HelpButton.vue?vue&type=script&lang=js"
export * from "./HelpButton.vue?vue&type=script&lang=js"

import "./HelpButton.vue?vue&type=style&index=0&id=521b9c3e&lang=scss&scoped=true"

import exportComponent from "F:\\PROMODUL\\Projets\\APP.LUMIERE+\\code\\lumiere_plus\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521b9c3e"]])

export default __exports__